import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IMinisiteSchemaPartial } from '../../../type/minisite';

export interface IUnpublishMinisiteDeveloperAnalyticsMutationFields {
  minisiteId: string;
  developerAnalyticIds: string[];
}


export interface IUnpublishMinisiteDeveloperAnalyticsMutationResponseFields {
  updatedMinisite: IMinisiteSchemaPartial;
}


export function unpublishMinisiteDeveloperAnalyticsMutation(fragment: string): DocumentNode {
  return gql`
        mutation unpublishMinisiteDeveloperAnalytics (
        $minisiteId: String!,
$developerAnalyticIds: [String]!
        ) {
        unpublishMinisiteDeveloperAnalytics (
        minisiteId: $minisiteId,
developerAnalyticIds: $developerAnalyticIds
        ) {
        ...fragment
        }
        }
        fragment fragment on UnpublishMinisiteDeveloperAnalyticsMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUnpublishMinisiteDeveloperAnalyticsMutation<TData extends Partial<IUnpublishMinisiteDeveloperAnalyticsMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ unpublishMinisiteDeveloperAnalytics: TData },
        IUnpublishMinisiteDeveloperAnalyticsMutationFields>,
) {
  return useMutation<{ unpublishMinisiteDeveloperAnalytics: TData },
      IUnpublishMinisiteDeveloperAnalyticsMutationFields>(
        unpublishMinisiteDeveloperAnalyticsMutation(fragment), options,
      );
}
